import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchLeads } from 'bundles/project/actions/index';

import EmailModal from 'bundles/project/components/email_modal';
import Leads from 'bundles/project/components/leads/leads';
import LeadsList from 'bundles/project/components/leads/list';
import LeadModal from 'bundles/project/components/leads/modal';
import { LAST_UPDATED } from 'bundles/leads/index/table/cell';

import './styles.scss';

export function ProjectLeads({
  availableDatabaseOptions,
  caDownloadPath,
  callLists,
  canDisplayEmailLink,
  commercialEdgeLogoPath,
  currentUser,
  defaultTaskAssignee,
  documentCenter,
  fetchLeads,
  leadReferralSources,
  leadsPath,
  leadStatuses,
  project
}) {
  useEffect(() => {
    fetchLeads(project.id);
  }, []);

  const [filters, setFilters] = useState({
    leadReferralSource: null,
    leadSearchText: '',
    leadStatus: null,
    listing: null,
    profileUserType: null,
  });

  const [leadsList, setLeadsList] = useState({
    page: 1,
    sortBy: { field: LAST_UPDATED, reverse: true },
  });

  const changeSort = (fieldClicked) => {
    setLeadsList((prevState) => {
      const prevSortBy = prevState.sortBy;
      const reverse = prevSortBy.field === fieldClicked ? !prevSortBy.reverse : false;

      return { ...prevState, sortBy: { field: fieldClicked, reverse } };
    });
  };

  const handleFilterChange = (filter) => {
    setFilters(prevState => ({ ...prevState, ...filter }));
  };

  const setPage = (page) => {
    setLeadsList(prevState => ({ ...prevState, page }));
  };

  return (
    <div className="deal-project-leads-tab">
      <Leads
        documentCenter={documentCenter || false}
        tasksEnabled={false}
      >
        <LeadsList
          availableDatabaseOptions={availableDatabaseOptions}
          caDownloadPath={caDownloadPath}
          callLists={callLists}
          callListsEnabled={currentUser && currentUser.callListsEnabled}
          canDisplayEmailLink={canDisplayEmailLink}
          changeSort={changeSort}
          commercialEdgeLogoPath={commercialEdgeLogoPath}
          databaseMembers={[...project.collaborators, ...project.otherAuthorizedUsers]}
          defaultTaskAssignee={defaultTaskAssignee}
          documentCenter={documentCenter}
          fromDealTab
          handleFilterChange={handleFilterChange}
          hasTasksEnabled={false}
          leadReferralSources={leadReferralSources}
          leadsPath={leadsPath}
          leadStatuses={leadStatuses}
          listingFilterValue={filters.listing}
          page={leadsList.page}
          profileUserTypeFilterValue={filters.profileUserType}
          referralSourceValue={filters.leadReferralSource}
          searchFilterValue={filters.leadSearchText}
          setPage={setPage}
          sort={leadsList.sortBy}
          statusFilterValue={filters.leadStatus}
          onStartImport={() => {}}
        />
      </Leads>

      <LeadModal leadReferralSources={leadReferralSources} leadStatuses={leadStatuses}/>
      <EmailModal projectTasksActivities={false}/>
    </div>
  );
}

ProjectLeads.propTypes = {
  availableDatabaseOptions: PropTypes.array,
  caDownloadPath: PropTypes.string,
  callLists: PropTypes.array,
  canDisplayEmailLink: PropTypes.bool,
  commercialEdgeLogoPath: PropTypes.string,
  currentUser: PropTypes.object,
  defaultTaskAssignee: PropTypes.object,
  documentCenter: PropTypes.bool,
  fetchLeads: PropTypes.func,
  leadReferralSources: PropTypes.array,
  leadsPath: PropTypes.string,
  leadStatuses: PropTypes.array,
  project: PropTypes.object,
};

const mapDispatchToProps = {
  fetchLeads
};

export default connect(null, mapDispatchToProps)(ProjectLeads);